module.exports = __webpack_public_path__ + "img/01.55b34e69.png";